import React from 'react';
import { useQuery } from 'react-query';
import { useIntl } from 'react-intl';
import * as DOMPurify from 'dompurify';
import API from '@wheeebo/polaris-api';
import { AsvIcon } from '@wheeebo/polaris-svg';
import VehicleMarker from './VehicleMarker';
function memberLabel(m) {
    if (!m)
        return undefined;
    const name = m.name?.trim();
    if (name)
        return name;
    const email = m.email?.trim();
    if (email)
        return email;
    return m.id;
}
const AsvMarker = ({ vehicleId, position, onVehicleClick, ...props }) => {
    const intl = useIntl();
    const [content, setContent] = React.useState();
    const [open, setOpen] = React.useState(false);
    const options = React.useMemo(() => ({ preload: ['active_flight_plan', 'operator', 'owner', 'groups'] }), []);
    const { data } = useQuery(API.Vehicles.getKey(vehicleId, options), () => API.Vehicles.get(vehicleId, options), {
        enabled: open,
    });
    const handleClick = React.useCallback(() => {
        setOpen((e) => !e);
        onVehicleClick?.(vehicleId);
    }, [vehicleId, onVehicleClick]);
    React.useEffect(() => {
        DOMPurify.setConfig({ ALLOWED_TAGS: [] });
        const lat = typeof position?.lat === 'function' ? position.lat() : position?.lat;
        const lng = typeof position?.lng === 'function' ? position.lng() : position?.lng;
        if (lat == null || lng == null || Number.isNaN(lat) || Number.isNaN(lng))
            return;
        const lines = [
            `<div style="padding-top: 0.25rem; padding-bottom: 0.25rem;">
        <span style="border-radius: 3px; border: 1px solid #888; padding: 0.15rem 0.75rem; font-size: 0.65rem">
        ASV</span>
      </div>
      <h2 style="margin-top: 0.5rem; margin-bottom: 0.5rem">${DOMPurify.sanitize(data?.name || '')}</h2>
      <div style="white-space: pre">${`${lat.toFixed(6)}   ${lng.toFixed(6)}`}</div>
      <div style="padding-top: 1rem"><table>`,
        ];
        const owner = memberLabel(data?.owner);
        if (owner) {
            lines.push(`<tr><td>Owner</td><td>${DOMPurify.sanitize(owner)}</td></tr>`);
        }
        const groupNames = data?.groups
            ?.map((g) => g.group?.name)
            .filter(Boolean)
            .join(', ');
        if (groupNames) {
            lines.push(`<tr><td>Groups</td><td>${DOMPurify.sanitize(groupNames)}</td></tr>`);
        }
        const operator = memberLabel(data?.activeFlightPlan?.operator);
        if (operator) {
            lines.push(`<tr><td>Operator</td><td>${DOMPurify.sanitize(operator)}</td></tr>`);
        }
        if (data?.activeFlightPlan?.startAt) {
            lines.push(`<tr><td>Started at</td><td>${intl.formatTime(data.activeFlightPlan.startAt, {
                year: 'numeric',
                month: 'numeric',
                day: '2-digit',
            })}</td></tr>`);
        }
        lines.push('</table></div>');
        setContent(lines.join(''));
    }, [data, position, intl]);
    return (React.createElement(VehicleMarker, { position: position, ...props, muiIcon: React.createElement(AsvIcon, null), scale: 0.15, symbolAnchor: new google.maps.Point(256, 256), popupContent: content, onClick: handleClick }));
};
export default React.memo(AsvMarker);
